var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAllFilesIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.58579 4.58579C9.96086 4.21071 10.4696 4 11 4H14.586C15.1164 4.00011 15.625 4.2109 16 4.586L18.414 7C18.7891 7.37499 18.9999 7.88361 19 8.414V14C19 14.5304 18.7893 15.0391 18.4142 15.4142C18.0391 15.7893 17.5304 16 17 16H11C10.4696 16 9.96086 15.7893 9.58579 15.4142C9.21071 15.0391 9 14.5304 9 14V6C9 5.46957 9.21071 4.96086 9.58579 4.58579Z",
  fill: "#636A7D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.58579 8.58579C5.21071 8.96086 5 9.46957 5 10V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H13C13.5304 20 14.0391 19.7893 14.4142 19.4142C14.7893 19.0391 15 18.5304 15 18H7V8C6.46957 8 5.96086 8.21071 5.58579 8.58579Z",
  fill: "#636A7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAllFilesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/allFiles-icon.63695e49637ba8320478979e4801a398.svg";